import React from 'react';
import { Card } from "react-bootstrap";
import face_wagner_tamas from "../../assets/img/face_wagner_tamas.png";
import ShowMoreText from "react-show-more-text";
import proj_traffic_signal from "../../assets/img/proj_traffic_signal.png";

const Tamas_Wagner_traffic_signal = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_traffic_signal} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_wagner_tamas}
              /* this will be the text on the banner */
              alt="Multi-objective reinforcement learning framework for traffic signal control"
            />{" "}
            <p className="text7">Tamás Wágner</p>
            <br />
            <p className="text8">
              PhD student{" "}
            </p>
            <p className="text8">BME Traffic Lab</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            The aim of the research is to develop a systematic methodology for the application of multi-objective reinforcement learning (MORL) 
            to traffic signal control. Traffic control is inherently a multi-objective optimization problem, where objectives such as minimizing 
            vehicle delay, queue lengths, number of stops, or environmental impact may be conflicting. Therefore, the selection of appropriate state 
            variables and optimization objectives has a significant influence on the resulting control strategy.
            <br />
            <br />
            In this task, students should investigate traffic-related input variables using statistical methods and determine which variables contain 
            relevant and non-redundant information for the control problem. Based on the selected inputs, different objective formulations and MORL 
            strategies should be evaluated in a microscopic traffic simulation environment.
            <br />
            <br />
            Particular attention should be paid to the relationships and trade-offs between the individual objectives. Instead of relying solely on a 
            predefined weighted reward function, the student should investigate Pareto-optimal solutions and analyze how different preferences between 
            objectives influence the resulting traffic control strategy.
            <br />
            <br />
            The final goal is to propose a general procedure for the systematic design of multi-objective reinforcement learning based traffic signal 
            control systems, covering input-variable selection, objective formulation, training, and performance evaluation.
      
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Tamas_Wagner_traffic_signal;